import { Button, styled } from "@mui/material";

export const ButtonPrimary = styled(Button)({
  minWidth: "166px",
  backgroundColor: "#007A5E",
  padding: "14px 16px",
  textTransform: "capitalize",
  borderRadius: "999px",
  fontWeight: "bold",
  color: "white",
  "&:hover": {
    backgroundColor: "#005743",
  }
});

export const ButtonRedirect = styled(Button)({
  minWidth: "100%",
  backgroundColor: "#007A5E",
  padding: "14px 16px",
  textTransform: "capitalize",
  borderRadius: "999px",
  fontWeight: "bold",
  color: "white",
  "&:hover": {
    backgroundColor: "#005743",
  }
});

export const ButtonSecondary = styled(Button)({
  minWidth: "166px",
  backgroundColor: "#7BC29A",
  padding: "14px 10px",
  textTransform: "capitalize",
  borderRadius: "999px",
  fontWeight: "bold",
  color: "white",
  "&:hover": {
    backgroundColor: "#569772",
  }
});

export const ButtonGreen = styled(Button)({
  minWidth: "166px",
  backgroundColor: "#23FF39",
  padding: "14px 10px",
  borderRadius: "999px",
  fontWeight: "bold",
  textTransform: "capitalize",
  color: "white",
  "&:hover": {
    backgroundColor: "#24ca34",
  }
});

export const ButtonRed = styled(Button)({
  minWidth: "166px",
  backgroundColor: "#FF1E1E",
  padding: "14px 10px",
  borderRadius: "999px",
  fontWeight: "bold",
  textTransform: "capitalize",
  color: "white",
  "&:hover": {
    backgroundColor: "#bd1a1a",
  }
});

export const ButtonDelete = styled(Button)({
  minWidth: "66px",
  backgroundColor: "red",
  padding: "14px 16px",
  textTransform: "capitalize",
  borderRadius: "999px",
  fontWeight: "bold",
  color: "white",
  "&:hover": {
    backgroundColor: "#005743",
  }
});

export const ButtonEdit = styled(Button)({
  minWidth: "66px",
  backgroundColor: "#007A5E",
  padding: "14px 16px",
  textTransform: "capitalize",
  borderRadius: "999px",
  fontWeight: "bold",
  color: "white",
  "&:hover": {
    backgroundColor: "#005743",
  }
});